import React from 'react';
import { useHistory } from 'react-router-dom';
import { TableList, Typography, TableListActions, DropdownMenu } from 'seagull';
import { CopyFill, TrashLiner24 } from 'seagull/icons';
import { routes } from "../../constants";
import { useStoreActions } from "../../contexts";
import { useDuplicateRelationship } from "../../hooks/useDuplicateRelationship";
import { useTerminateAgreement } from "../../hooks/useTerminateAgreement";
import { getUICompanyName } from "./DraftsDashboard.utils";
import { timeModel } from "../../models";
export default function DraftsDashboardRow(props) {
  var _draft$lastModifiedBy, _draft$lastModifiedBy2;
  const {
    draft,
    index,
    refresh
  } = props;
  const {
    logBI
  } = useStoreActions();
  const history = useHistory();
  const {
    duplicateDraftFromId
  } = useDuplicateRelationship();
  const {
    terminateDraftById
  } = useTerminateAgreement();
  const draftLabel = getUICompanyName(draft);
  const draftSubLabel = draft.title;
  return /*#__PURE__*/React.createElement(TableList.Row, {
    key: draft.id,
    rowId: draft.id,
    "data-testid": "drafts-row",
    "data-heapid": "draft",
    as: 'button',
    to: routes.draft(draft.id),
    onClick: () => {
      logBI(10352);
      history.push(routes.draft(draft.id));
    },
    items: [{
      value: draftLabel.length > 0 ? /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true,
        weight: "normal",
        "data-testid": "draft-company-name-".concat(index)
      }, draftLabel, draftSubLabel.length > 0 && /*#__PURE__*/React.createElement(Typography, {
        as: "span",
        variant: "paragraph2",
        skin: "secondary",
        "data-testid": "draft-name-".concat(index)
      }, ' ', "(", draftSubLabel, ")")) : /*#__PURE__*/React.createElement(Typography, {
        as: "span",
        variant: "paragraph2",
        skin: "secondary",
        "data-testid": "draft-name-".concat(index)
      }, "(", draftSubLabel || 'Unnamed Draft', ")")
    }, {
      value: /*#__PURE__*/React.createElement(Typography, null, "".concat((_draft$lastModifiedBy = draft.lastModifiedBy) === null || _draft$lastModifiedBy === void 0 ? void 0 : _draft$lastModifiedBy.firstName, " ").concat((_draft$lastModifiedBy2 = draft.lastModifiedBy) === null || _draft$lastModifiedBy2 === void 0 ? void 0 : _draft$lastModifiedBy2.lastName))
    }, {
      value: /*#__PURE__*/React.createElement(Typography, {
        skin: "secondary"
      }, timeModel.formatTimeAgo(draft.lastModifiedOn))
    }],
    actionColumn: /*#__PURE__*/React.createElement(TableListActions, {
      buttonText: "View",
      testId: "table-list-actions-".concat(index),
      btnHeapId: "draft-view-btn",
      menuHeapId: "draft-menu-btn",
      onClickButton: () => history.push(routes.draft(draft.id))
    }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      onClick: () => duplicateDraftFromId(draft.id),
      iconStart: /*#__PURE__*/React.createElement(CopyFill, null),
      "data-testid": "table-list-actions-duplicate-".concat(index),
      "data-heapid": "draft-menu-duplicate"
    }, "Duplicate Draft"), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      onClick: () => terminateDraftById(draft.id, () => refresh()),
      skin: "error",
      iconStart: /*#__PURE__*/React.createElement(TrashLiner24, null),
      "data-testid": "table-list-actions-discard-".concat(index),
      "data-heapid": "draft-menu-discard"
    }, "Discard Draft"))
  });
}